import {
    ClearSelectedInspectionAction,
    InitInspectionListAction,
    InspectionAction,
    SelectedInspectionAction,
    ChangeExcelEndDateAction,
    ChangeExcelStartDateAction,
    ChangeSelectedInspectionAction,
    InitInspectionSubQuestionAction,
    ChangeInspectionQuestionParentIdAction,
} from "./action";
import { ESSSubQeustionList, InsepectionDetail, InspectionList } from "./state";
import { Dispatch } from "redux";

export function initInspectionListThunk(inspectionList: InspectionList[]) {
    return (dispatch: Dispatch<InspectionAction>) => {
        dispatch(InitInspectionListAction(inspectionList));
    };
}

export function initSelectedInspectionThunk(
    inspectionDetail: InsepectionDetail,
    selected_inspection:InspectionList
) {
    return (dispatch: Dispatch<InspectionAction>) => {
        dispatch(SelectedInspectionAction(inspectionDetail,selected_inspection));
    };
}

export function clearSelectedInspectionThunk() {
    return (dispatch: Dispatch<InspectionAction>) => {
        dispatch(ClearSelectedInspectionAction());
    };
}

export function ChangeExcelStartDateThunk(date: Date){
    return(dispatch: Dispatch<InspectionAction>) => {
        dispatch(ChangeExcelStartDateAction(date))
    }
}

export function ChangeExcelEndDateThunk(date: Date){
    return(dispatch: Dispatch<InspectionAction>) => {
        dispatch(ChangeExcelEndDateAction(date))
    }
}

export function ChaneSelectedInspectionThunk(selected_inspection:InspectionList){
        return(dispatch: Dispatch<InspectionAction>) => {
        dispatch(ChangeSelectedInspectionAction(selected_inspection))
    }
}

export function InitInspectionSubQuestionThunk(subQuestionList:ESSSubQeustionList[]){
        return(dispatch: Dispatch<InspectionAction>) => {
        dispatch(InitInspectionSubQuestionAction(subQuestionList))
    }
}

export function ChangeInspectionQuestionParentIdThunk(selected_parent_question_id:number){
      return(dispatch: Dispatch<InspectionAction>) => {
        dispatch(ChangeInspectionQuestionParentIdAction(selected_parent_question_id))
    }
}

